export const getSecuredFieldStyles = (theme) => ({
  base: {
    color: theme === "dark" ? "#FFFFFF" : "#27272A",
    caretColor: theme === "dark" ? "#FFFFFF" : "#27272A",
    fontSize: "14px",
    "::placeholder": {
      color: theme === "dark" ? "#71717A" : "#7A7A83"
    }
  },
  error: {
    color: theme === "dark" ? "#FFFFFF" : "#27272A"
  },
  validated: {
    color: theme === "dark" ? "#FFFFFF" : "#27272A"
  }
})

export const getAdyenErrorMessage = (result) => {
  if (!result) return "Payment failed"

  switch (result) {
    case "Refused":
      return "Payment was refused"
    case "Cancelled":
      return "Payment was cancelled"
    case "Error":
      return "Payment error occurred"
    default:
      return "Payment failed"
  }
}

export const observeAdyenError = (message) => {
  const observer = new MutationObserver(() => {
    const el = document.querySelector(".adyen-checkout__status__text")

    if (el) {
      el.textContent = message
      observer.disconnect()
    }
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true
  })
}

export const hideGooglePayIfNeeded = (isShowCards) => {
  if (isShowCards) return

  const hide = () => {
    const nodes = document.querySelectorAll(
      ".adyen-checkout__payment-method--googlepay, .adyen-checkout__payment-method--applepay"
    )

    nodes.forEach((el) => {
      el.style.display = "none"
    })
  }

  hide()

  const observer = new MutationObserver(() => {
    hide()
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true
  })

  return () => observer.disconnect()
}
